import { Link } from "react-router-dom";
import { getHot, typeLabel } from "@/lib/movies";
import RatingBadge from "@/components/base/RatingBadge";

export default function RankingSection() {
  const list = getHot(5);

  return (
    <section className="w-full px-4 md:px-8 mt-10 md:mt-14">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2">
            <i className="ri-fire-fill text-accent-500" />
            热播榜单
          </h2>
          <p className="mt-1 text-sm text-foreground-500">天天影院本周综合评分与热度 TOP 5</p>
        </div>
        <Link
          to="/category/movie"
          className="text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          更多榜单
          <i className="ri-arrow-right-line ml-1" />
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-5">
        {list.map((movie, index) => (
          <Link
            key={movie.id}
            to={`/detail/${movie.id}`}
            className="group relative block rounded-lg overflow-hidden cursor-pointer"
          >
            <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
              <img
                src={movie.cover}
                alt={`${movie.title} 海报`}
                title={`${movie.title} - 天天影院影视详情`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/10 to-transparent" />
              <span
                className={`absolute top-2 left-2 w-7 h-7 flex items-center justify-center rounded-md font-heading font-bold text-sm ${
                  index === 0
                    ? "bg-accent-500 text-background-50"
                    : "bg-background-50/90 text-primary-700"
                }`}
              >
                {index + 1}
              </span>
              <div className="absolute bottom-0 inset-x-0 p-3">
                <div className="flex items-center gap-2 mb-1">
                  <RatingBadge rating={movie.rating} size="sm" />
                  <span className="text-[11px] text-background-200">{typeLabel(movie.type)}</span>
                </div>
                <h3 className="text-sm font-medium text-background-50 line-clamp-1">
                  {movie.title}
                </h3>
                <p className="text-[11px] text-background-300/80 line-clamp-1">
                  {movie.genres.join(" · ")}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}